import { Menu } from "antd";
import {
  BarsOutlined,
  FileTextOutlined,
  SafetyOutlined,
} from "@ant-design/icons";
import FaqIcon from "../assets/wpf_faq.svg";
import RechargeIcon from "../assets/recharge.svg";
import ContactUsIcon from "../assets/contactUs.svg";

function HelpMenu({ 
  toggle, 
  onOpenFaqs, 
  onOpenContactUs, 
  onRecharge, 
  onOpenSchedules, 
  onOpenTerms, 
  onOpenPrivacy 
}) {
  return (
    <>
      <style>
        {`
          .sleek-menu.ant-menu-inline,
          .sleek-menu.ant-menu-vertical {
            border: none !important;
            background: transparent !important;
          }
          
          .sleek-menu .ant-menu-submenu-title {
            padding: 12px 8px !important;
            margin: 0 !important;
            border-radius: 10px !important;
            transition: all 0.2s ease !important;
            height: auto !important;
            display: flex !important;
            align-items: center !important;
          }
          
          .sleek-menu .ant-menu-submenu-title .ant-menu-title-content {
            display: flex !important;
            align-items: center !important;
            gap: 10px !important;
            flex: 1 !important;
          }
          
          .sleek-menu .ant-menu-submenu-title .ant-menu-item-icon {
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
          }
          
          .sleek-menu .ant-menu-submenu-title:hover {
            background: #e6e5e5 !important;
          }
          
          .sleek-menu .ant-menu-submenu-arrow {
            color: #E61F26 !important;
            font-size: 10px !important;
            transition: transform 0.2s ease !important;
          }
          
          .sleek-menu .ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-submenu-arrow {
            transform: rotate(180deg) !important;
          }
          
          .sleek-menu .ant-menu-sub {
            background: transparent !important;
            padding: 4px 0 !important;
          }
          
          .sleek-menu .ant-menu-item {
            padding: 10px 12px 10px 40px !important;
            margin: 2px 0 !important;
            height: auto !important;
            line-height: 1.4 !important;
            border-radius: 8px !important;
            transition: all 0.2s ease !important;
          }
          
          .sleek-menu .ant-menu-item:hover {
            background: #f0f0f0 !important;
          }
          
          .sleek-menu .ant-menu-item-selected {
            background: transparent !important;
          }
          
          .sleek-menu .ant-menu-item::after {
            display: none !important;
          }
          
          .sleek-menu .ant-menu-title-content {
            display: flex !important;
            align-items: center !important;
            gap: 10px !important;
          }
          
          .sleek-menu .ant-menu-item-icon {
            font-size: 18px !important;
            min-width: 20px !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
          }

          .sleek-menu .ant-menu-inline-collapsed .ant-menu-submenu-title {
            padding: 12px !important;
            justify-content: center !important;
          }

          .sleek-menu .ant-menu-inline-collapsed .ant-menu-item-icon {
            font-size: 20px !important;
          }
        `}
      </style>

      <Menu
        mode="vertical"
        inlineCollapsed={!toggle}
        className="sleek-menu border-none bg-transparent"
        items={[
          {
            key: "help-info",
            label: toggle ? (
              <span className="text-[#E61F26] font-Poppins text-[13px] font-[600]">
                Help & Info
              </span>
            ) : null,
            icon: <BarsOutlined className="!text-[#E61F26]" />,
            children: [
              {
                key: "faqs",
                icon: (
                  <img
                    src={FaqIcon}
                    alt="FAQ"
                    className="w-5 h-5"
                  />
                ),
                label: (
                  <span className="text-[#E61F26] font-Poppins text-[13px] font-[500]">
                    FAQs
                  </span>
                ),
                onClick: onOpenFaqs,
              },
              {
                key: "contact",
                icon: (
                  <img
                    src={ContactUsIcon}
                    alt="Contact"
                    className="w-5 h-5"
                  />
                ),
                label: (
                  <span className="text-[#E61F26] font-Poppins text-[13px] font-[500]">
                    Contact Us
                  </span>
                ),
                onClick: onOpenContactUs,
              },
              {
                key: "recharge",
                icon: (
                  <img
                    src={RechargeIcon}
                    alt="Recharge"
                    className="w-5 h-5"
                  />
                ),
                label: (
                  <span className="text-[#E61F26] font-Poppins text-[13px] font-[500]">
                    Recharge
                  </span>
                ),
                onClick: onRecharge,
              },
              {
                key: "schedules",
                icon: (
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="#E61F26"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                    />
                  </svg>
                ),
                label: (
                  <span className="text-[#E61F26] font-Poppins text-[13px] font-[500]">
                    Schedules
                  </span>
                ),
                onClick: onOpenSchedules,
              },
              {
                key: "terms",
                icon: (
                  <FileTextOutlined className="!text-[#E61F26]" />
                ),
                label: (
                  <span className="text-[#E61F26] font-Poppins text-[13px] font-[500]">
                    Terms of Use
                  </span>
                ),
                onClick: onOpenTerms,
              },
              {
                key: "privacy",
                icon: (
                  <SafetyOutlined className="!text-[#E61F26]" />
                ),
                label: (
                  <span className="text-[#E61F26] font-Poppins text-[13px] font-[500]">
                    Privacy Policy
                  </span>
                ),
                onClick: onOpenPrivacy,
              },
            ],
          },
        ]}
      />
    </>
  );
}

export default HelpMenu;